module.exports = __webpack_public_path__ + "media/images/city_img/t_4-5b3318a576c59beceb385132297585b9.png";